import React, { useCallback, useEffect, useState } from "react";
import Footer from "../../assets/images/Footer.png";
import { Link, useParams } from "react-router-dom";
import useHttp from "../../hooks/use-http";
import MiniNavigation from "../MiniNavigation";

const SupportedBanks = () => {
  const [transactionInfo, setTransactionInfo] = useState({});
  const { sendRequest: fetchTransactionDetails } = useHttp();

  const { id } = useParams();

  const getTransactionInfo = (data) => {
    setTransactionInfo(data);
  };

  const fetchTransactionInfo = useCallback(async () => {
    fetchTransactionDetails(
      {
        url: `${process.env.REACT_APP_BASE_URL}/api/sandbox/checkout/${id}`,
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      },
      getTransactionInfo
    );
  }, [fetchTransactionDetails, id]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchTransactionInfo();
    };

    fetchData();
  }, [fetchTransactionInfo]);
  const banks = [
    "Payattitude",
    "HopePSBank",
    "Zenith Bank.",
    "Union Bank.",
    "Access bank",
    "Ecobank",
    "UBA",
    "Heritage Bank",
    "Polaris Bank",
    "First Bank of Nigeria.",
    "Fidelity Bank.",
    "Sterling Bank.",
    "Wema Bank.",
    "eNaira.",
  ];
  return (
    <div className="flex flex-col items-center justify-center lg:mr-[200px] mx-auto font-LT">
      <MiniNavigation />
      <div className="md:w-[562px] w-[300px] mt-28 xl:ml-5">
        <div className="flex justify-between">
          <p className="text-primary xl:text-xl text-lg font-bold">
            {transactionInfo?.data?.merchantName}
          </p>
          <div>
            <p className="xl:text-2xl text-xl text-primary font-bold">
              <span className="text-xl">{transactionInfo?.data?.currency}</span>{" "}
              {transactionInfo?.data?.amount}
            </p>
            <p className="text-sm text-primary font-normal">
              (Fee NGN {transactionInfo?.data?.fee})
            </p>
            <p className="text-[17.75px] text-normalText font-normal">
              {transactionInfo?.data?.customerEmail || transactionInfo?.data?.email}
            </p>
          </div>
        </div>
        <div className="flex justify-centerw-[534px] mt-4">
          <p className="font-bold text-[18.75px] text-darkGrey text-center w-[419px]">
            How to Pay with Phone Number - Supported Banks
          </p>
        </div>
        <div className="mt-4">
          <p className="text-[18.75px] md:w-[418.18px] font-normal text-darkGrey">
            Please see the list of Payattitude supported banks below.
          </p>
        </div>
        <ul className="px-4 ml-5 list-disc">
          {banks.map((bank, index) => (
            <li className="text-darkGrey text-[18.75px] font-normal">{bank}</li>
          ))}
        </ul>
        <Link to={`/${id}`}>
          <div className="flex justify-center mt-6">
            <button className=" text-white text-[14.75px] font-medium w-[307px] rounded-[10px] bg-primary py-[20.19px] mb-2">
              Back to Payment
            </button>
          </div>
        </Link>
        {!localStorage.getItem("AppName") && (
          <div className="flex justify-center mt-6 mb-2">
            <img src={Footer} alt="footerLogo" className="w-[227px]" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportedBanks;
